import { Grid, IconButton, Typography } from "@mui/material";

function Modal({
  title,
  icon,
  backgroundColor = "var(--emr-white)",
  width = "100%",
  background = undefined,
  actionButton = undefined,
  titleVariant = "h6",
  onClick = undefined,
  sx = {},
  children,
}) {
  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        onClick={onClick}
        sx={{
          background: background,
          backgroundColor: background ? undefined : backgroundColor,
          boxShadow: "0px 0px 4px 0px #14B8A640",
          padding: "10px",
          borderRadius: "10px",
          width: width,
          cursor: onClick ? "pointer" : "unset",
          ...sx,
        }}
      >
        <Grid
          display={"flex"}
          flexDirection={"row"}
          alignContent={"center"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid
            display={"flex"}
            flexDirection={"row"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <IconButton>{icon}</IconButton>
            <Typography
              variant={titleVariant}
              sx={{ color: "var(--emr-primary)" }}
            >
              {title}
            </Typography>
          </Grid>
          {actionButton && actionButton}
        </Grid>
        {children}
      </Grid>
    </>
  );
}

export default Modal;
